import styled, { css } from 'styled-components';
import _ from 'lodash';
import { mapRoleToBackgroundColor } from '../theme';
import './types';
import zenscroll from 'zenscroll';

export const ShadowStyle = css`
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 0px 6px rgba(0, 0, 0, 0.15);
`;

export const scrollToRefObject = (ref) => zenscroll.toY(ref.current.offsetTop);

export const fibonacci = _.memoize(function (n = 0) {
  return n < 2 ? n : fibonacci(n - 1) + fibonacci(n - 2);
});

export const Grid = styled.div<GridType>`
  display: grid;
  align-items: ${({ align }) => align};
  grid-gap: ${({ theme, space = 3 }) => theme.baseSpace * space}px;
  grid-template-columns: ${({ theme, columns }) => {
    return columns
      ? _.range(columns)
          .map(() => '1fr')
          .join(' ')
      : `repeat(auto-fill,minmax(${theme.baseSpace * fibonacci(9)}px, 1fr))`;
  }};
  grid-auto-rows: 1fr;
`;

export const dimensionToStyle = (size, baseSpace) => {
  if (_.isUndefined(size)) {
    return;
  }
  return _.isString(size) ? size : `${fibonacci(size) * baseSpace}px`;
};

const CenterStyle = css`
  align-items: center;
  display: flex;
  justify-content: center;
  flex: 1;
  align-self: center;
`;

export const DisabledStyle = css`
  opacity: ${({ disabled }: any) => (disabled ? '0.1' : 1)};
  pointer-events: ${({ disabled }: any) => (disabled ? 'none' : 'all')};
`;
export const DimensionStyle = css<DimensionType>`
  width: ${({ width, theme }) => dimensionToStyle(width, theme.baseSpace)};
  height: ${({ height, theme }) => dimensionToStyle(height, theme.baseSpace)};
  max-height: ${({ maxHeight }) => maxHeight};
  max-width: ${({ maxWidth }) => maxWidth};
  /* overflow-y: ${({ maxHeight }) => (maxHeight ? 'scroll' : 'visible')}; */
`;

export const BackgroundStyle = css<BackgroundType>`
  background-color: ${({ backgroundRole }: any) =>
    mapRoleToBackgroundColor(backgroundRole)};
`;

export const InteractiveStyle = css`
  cursor: pointer;
  outline: none;
`;

export const Stack = styled.div<StackType & DimensionType & BackgroundType>`
  display: grid;
  grid-gap: ${({ theme, size }: any) => theme.baseSpace * fibonacci(size)}px;
  grid-template-columns: 1fr;
  position: relative;
  ${DimensionStyle}
  ${BackgroundStyle}
`;
export const Queue = styled.div<QueueType & DimensionType & BackgroundType>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'inherit'};
  & > * + * {
    margin-left: ${({ theme, size }) => theme.baseSpace * fibonacci(size)}px;
  }
  align-items: ${({ alignVertical }) => alignVertical || 'center'};
  ${({ center }) => center && CenterStyle};
  overflow-x: hidden;
  ${DimensionStyle}
  ${BackgroundStyle}
`;

export const Container = styled.div<ContainerType & BackgroundType>`
  margin: 0 auto;
  max-width: ${({ theme }) => theme.desktop}px;
  position: relative;
`;

export const Margin = styled.div<MarginType>`
  margin: ${({ theme, size }) =>
    !_.isArray(size)
      ? `${fibonacci(size) * theme.baseSpace}px`
      : size.map((d) => `${fibonacci(d) * theme.baseSpace}px`).join(' ')};
  ${DimensionStyle}
  ${BackgroundStyle}
`;

export const Padding = styled.div<PaddingType & DimensionType & BackgroundType>`
  position: relative;
  padding: ${({ theme, size }) =>
    !_.isArray(size)
      ? `${fibonacci(size) * theme.baseSpace}px`
      : size.map((d) => `${fibonacci(d) * theme.baseSpace}px`).join(' ')};
  ${DimensionStyle}
  ${BackgroundStyle}
`;
const sideSpacing = (key) => ({ theme, ...props }) => {
  let side = _.property(key)(props);
  if (_.isUndefined(side)) {
    return;
  }
  return dimensionToStyle(side, theme.baseSpace);
};
export const Overlay = styled.div<OverlayType & DimensionType & BackgroundType>`
  position: ${({ relative }) => (relative ? 'relative' : 'absolute')};
  z-index: ${({ zIndex }) => zIndex};
  top: ${sideSpacing('top')};
  right: ${sideSpacing('right')};
  left: ${sideSpacing('left')};
  bottom: ${sideSpacing('bottom')};
  display: flex;
  ${DimensionStyle}
  ${BackgroundStyle}
`;

export const Center = styled.div<DimensionType & BackgroundType>`
  ${CenterStyle}
  ${DimensionStyle}
    ${BackgroundStyle}
`;

export const Flex = styled.div<any>`
  display: ${({ row }) => row && 'flex'};
  flex: ${({ flex }: any) => flex};
  position: ${({ absolute }: any) => (absolute ? 'absolute' : 'relative')};
  ${DimensionStyle}
  ${BackgroundStyle}
`;
